import React from "react";
import ProductPricesHub from "components/ProductPricesHub";
import ProductCreate from "components/ProductForm/Create";
import ProductEdit from "components/ProductForm/Edit";
import { useRouter } from "next/router";
import { QUERY_PARAM_KEY } from "utils/constants/query";
import { useQueryParamReferences } from "utils/selectors";
import { PRODUCT } from "utils/constants/models";

const DEFAULT_CLASSES = {
  create: "w-100 bg-white pt0 pt4-l",
  edit: "w-100 bg-white"
};

const COPY_DEFAULTS = {
  header: "Products",
  subheader: "Create and manage your products for sale."
};

const INTENT = {
  CREATE: `${PRODUCT}s/create`
};

const ProductsSection = ({ customClasses, header, subheader }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const copy = {
    header: header || COPY_DEFAULTS.header,
    subheader: subheader || COPY_DEFAULTS.subheader
  };

  const { query } = useRouter();
  const paramReferences = useQueryParamReferences(query.param);
  const uuid = paramReferences[QUERY_PARAM_KEY.PRODUCT_UUID];

  const createRoute = query.param && query.param.join("/") === INTENT.CREATE;

  let content;
  if (createRoute) {
    content = (
      <div className={classes.create}>
        <ProductCreate />
      </div>
    );
  } else if (uuid) {
    content = (
      <div className={classes.edit}>
        <ProductEdit />
      </div>
    );
  } else {
    content = (
      <ProductPricesHub
        header={copy.header}
        subheader={copy.subheader}
        /**
         * Override index props for ProductsSection rendered in Editor
         * We need that content to overscroll-y
         */
        customClasses={classes.index}
      />
    );
  }

  return content;
};

export default ProductsSection;
